import { combineReducers } from 'redux';
import smartSheetReducer from './smartSheetReducers';
import adaptivePracticeReducer from './AdaptivePracticeReducers';
import userReducer from './userReducers';

export default combineReducers({ userReducer, adaptivePracticeReducer, smartSheetReducer });